import { announce } from '@/util/live_announcer'

export function usePickedUuids(
  selected: () => string[],
  emitSelected: (uuids: string[]) => void,
  emitAdded: (uuid: string) => void,
  noun: string
) {
  function add(uuid: string, label: string) {
    if (selected().includes(uuid)) {
      announce(`${label} is already selected`)
      return
    }
    emitSelected([...selected(), uuid])
    emitAdded(uuid)
    announce(`Added ${noun} ${label}`)
  }

  function remove(index: number) {
    emitSelected(selected().filter((_, i) => i !== index))
  }

  return { add, remove }
}
